function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 71,
  cy: 69,
  rx: 71,
  ry: 69,
  fill: "#0072CE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95 25V20L75 20L67 30L92 30L95 25Z",
  fill: "#E9E9E9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M99 21C99 20.4477 98.5523 20 98 20H95V25H98C98.5523 25 99 24.5523 99 24V21Z",
  fill: "#41AEFE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M95 25L91 30L98.0075 37.7925C98.3667 38.1919 99.017 37.8213 98.8564 37.3087L95 25Z",
  fill: "#41AEFE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M80 30H88V41H80V30Z",
  fill: "#DEDEDE"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 73,
  y: 40,
  width: 22,
  height: 68,
  rx: 2,
  fill: "#E9E9E9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M73 54H95V90H73V54Z",
  fill: "#B7DFFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M57.3104 39C57.3104 38.4477 57.7581 38 58.3104 38H67.1724C67.7247 38 68.1724 38.4477 68.1724 39V44.1429C68.1724 44.6951 67.7247 45.1429 67.1724 45.1429H58.3104C57.7581 45.1429 57.3104 44.6951 57.3104 44.1429V39Z",
  fill: "#B7DFFF"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 43.0943,
  width: 30,
  height: 64.9057,
  rx: 2,
  fill: "#FED402"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9331 76.3132C26.7197 75.6663 27.2015 75 27.8828 75H110.641C111.315 75 111.796 75.6536 111.596 76.2973L101.942 107.297C101.812 107.715 101.425 108 100.987 108H38.1062C37.6746 108 37.2917 107.723 37.1565 107.313L26.9331 76.3132Z",
  fill: "#C0C0C0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M66.5 71L71.5 69L86.5 68L90.5 69.5L95 69L96.5 69.5L103.5 80.5L103 82.5L101 84.5L98 84L93 77H91.5L93 83L94 93L93.5 95.5L92.5 97.5L90 98L88.5 97L88 96L87 85.5L84 77L85.5 91.5V96.5L85 97.5L84 98L82.5 98.5L80 97L77.5 78.5L78.5 95V97L77.5 98L76 98.5L74.5 98L73.5 97L73 91.5L71.5 77.5V94L71 96L70 97L67.5 96.5L66.5 94L65 77L66.5 71Z",
  fill: "#41AEFE"
});

function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 138,
    viewBox: "0 0 142 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.066839de8898f0315a2b2a340716c1e3.svg";
export { ForwardRef as ReactComponent };